import { useStrings } from "../../i18n/index.tsx";
import { COL, FOCUS } from "../../theme.ts";
import { Mascot } from "../Mascot.tsx";
import { Btn } from "../primitives.tsx";

interface GateProps {
	minutesLeft: number;
	onTurnOn: () => void;
	onBack: () => void;
}

/** Shown instead of a round that needs sound while listening is off. */
export function Gate({ minutesLeft, onTurnOn, onBack }: GateProps) {
	const t = useStrings();
	return (
		<div
			data-testid="listening-gate"
			className="mx-auto flex min-h-screen max-w-md flex-col items-center justify-center gap-4 px-6 text-center"
		>
			<Mascot state="idle" size={140} />
			<h2 className="text-2xl font-extrabold">{t("listen.gateTitle")}</h2>
			<p style={{ color: COL.mute }}>{t("listen.backIn", { n: minutesLeft })}</p>
			<div className="mt-4 flex w-full flex-col gap-3">
				<Btn onClick={onTurnOn}>{t("listen.turnOn")}</Btn>
				<button
					type="button"
					onClick={onBack}
					className={`rounded-lg py-2 font-semibold ${FOCUS}`}
					style={{ color: COL.mute }}
				>
					{t("listen.back")}
				</button>
			</div>
		</div>
	);
}
